<div class="full-height" fxLayout="column">
  @if (!showLoader) {
    <div class="iframe-content mat-app-background full-height">
      <iframe [srcdoc]="dashboard | sanitizeHtml"  width="100%" height="100%" id="iframe" title="dashboard"></iframe>
    </div>
  }
  @if (showLoader) {
    <div fxLayoutAlign="center center" class="full-height">
      <img src="../../../../assets/images/loader.gif" class="loader-img" alt="loader" />
    </div>
  }
</div>
